import { Tooltip, TableProPlus, TooltipProps } from "@gw/web-basic-components";
import React, { CSSProperties } from "react";

const { useFilter } = TableProPlus;

export type RefreshIconProps = {
  className?: string;
  style?: CSSProperties;
  tooltip?: TooltipProps;
};

/** 表格页面刷新组件 */
const RefreshIcon: React.FC<RefreshIconProps> = (props) => {
  const { commitOnceMore } = useFilter();
  const { tooltip } = props;

  return (
    <Tooltip {...tooltip} title={tooltip?.title || "刷新"}>
      <svg
        viewBox="0 0 34 34"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={
          props.className
            ? `${props.className} wbuc-table-pro-plus-refresh-icon`
            : "wbuc-table-pro-plus-refresh-icon"
        }
        style={{ ...props.style, cursor: "pointer" }}
        onClick={() => {
          commitOnceMore();
        }}
      >
        <defs>
          <filter
            x="-2.9%"
            y="-2.9%"
            width="105.9%"
            height="105.9%"
            filterUnits="objectBoundingBox"
            id="wbuc_refresh_svg_filter"
          >
            <feGaussianBlur
              stdDeviation="1"
              in="SourceAlpha"
              result="shadowBlurInner1"
            ></feGaussianBlur>
            <feOffset
              in="shadowBlurInner1"
              result="shadowOffsetInner1"
            ></feOffset>
            <feComposite
              in="shadowOffsetInner1"
              in2="SourceAlpha"
              operator="arithmetic"
              k2="-1"
              k3="1"
              result="shadowInnerInner1"
            ></feComposite>
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
              in="shadowInnerInner1"
            ></feColorMatrix>
          </filter>
          <path
            d="M4 0h26a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Z"
            id="wbuc_refresh_svg_path"
          ></path>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g>
            <use fill="transparent" xlinkHref="#wbuc_refresh_svg_path"></use>
            <use
              fill="#000"
              filter="url(#wbuc_refresh_svg_filter)"
              xlinkHref="#wbuc_refresh_svg_path"
            ></use>
          </g>
          <path d="M17 25a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"></path>
          <path
            d="M10.63 15.61a.5.5 0 0 1 .425.565 6 6 0 0 0 7.466 6.63l-.19-.134-.07-.058a.5.5 0 0 1 .563-.807l.079.045 1.052.735.059.058.05.07.02.035.025.062.014.05.01.055.002.082-.007.058-.03.105-.501 1.221-.042.08a.5.5 0 0 1-.91-.373l.027-.086.093-.23-.187.047a7 7 0 0 1-8.513-7.783.5.5 0 0 1 .564-.427Zm4.448-6.255a.5.5 0 0 1 .271.58l-.03.084-.1.212.203-.05a7 7 0 0 1 7.948 9.721.5.5 0 1 1-.91-.415 6 6 0 0 0-6.966-8.295l.195.152a.5.5 0 0 1-.535.84l-.076-.05-1.045-.806-.054-.05-.043-.05-.038-.06-.017-.036-.02-.052-.017-.075-.004-.042.004-.103.015-.069.01-.033.544-1.163a.5.5 0 0 1 .665-.24ZM17 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
            fill="currentColor"
            fillRule="nonzero"
          ></path>
        </g>
      </svg>
    </Tooltip>
  );
};

export default RefreshIcon;
